var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 72,
    viewBox: "0 0 75 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.171875,
    y: 0.608398,
    width: 74,
    height: 71,
    rx: 35.5,
    fill: "#5926F0",
    fillOpacity: 0.47
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3125 46.4178L35.3427 35.98L28.4986 25.7998H32.1641L37.1897 33.4457L42.1867 25.7998H45.8665L39.0224 35.98L46.0383 46.4178H42.3729L37.1897 38.5286L31.9922 46.4178H28.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d4c3a924d4624c5eaf5a12aec5f33cc6.svg";
export { ForwardRef as ReactComponent };